import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from './ui/card';
import { Button } from './ui/button';
import {
  ClockIcon,
  AlertTriangleIcon,
  CheckCircleIcon,
  ArrowRightIcon
} from 'lucide-react';

const InviteExpired = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-blue-50 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full p-8 shadow-2xl">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center">
            <ClockIcon className="w-10 h-10 text-orange-600" />
          </div>
        </div>

        {/* Title */}
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Davet Linkinizin Süresi Doldu
          </h1>
          <p className="text-gray-600 text-lg">
            Üzgünüz, bu davet linkinin geçerlilik süresi sona ermiş.
          </p>
        </div>

        {/* Info Box */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
          <div className="flex items-start space-x-3">
            <AlertTriangleIcon className="w-6 h-6 text-blue-600 mt-1 flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-blue-900 mb-2">Ç
ok Bekledik! 😊</h3>
              <p className="text-blue-800 text-sm leading-relaxed">
                Davet linkinizin geçerlilik süresi <strong>21 gün</strong> olup bu süre dolmuştur. 
                Ancak endişelenmeyin! Hâlâ platformumuza katılabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        {/* Benefits */}
        <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-6 mb-6">
          <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2" />
            Ücretsiz Üyelik Avantajları
          </h3>
          <ul className="space-y-3">
            <li className="flex items-start">
              <CheckCircleIcon className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
              <span className="text-gray-700"><strong>14 Gün Ücretsiz Deneme</strong> - Tüm özelliklere tam erişim</span>
            </li>
            <li className="flex items-start">
              <CheckCircleIcon className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
              <span className="text-gray-700"><strong>Kredi Kartı Gerekmez</strong> - Hemen başlayın</span>
            </li>
            <li className="flex items-start">
              <CheckCircleIcon className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
              <span className="text-gray-700"><strong>İptal Garantisi</strong> - İstediğiniz zaman iptal edebilirsiniz</span>
            </li>
            <li className="flex items-start">
              <CheckCircleIcon className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
              <span className="text-gray-700"><strong>Tam Destek</strong> - Kurulum ve kullanım desteği</span>
            </li>
          </ul>
        </div>

        {/* CTA */}
        <div className="text-center space-y-4">
          <p className="text-gray-700 font-medium">
            Web sitemize girerek ücretsiz üyeliğinizi hemen aktif hale getirebilirsiniz!
          </p>
          
          <Button
            onClick={() => navigate('/register')}
            className="w-full py-6 text-lg font-bold bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
          >
            <span className="text-2xl mr-3">DEVAM</span>
            <ArrowRightIcon className="w-6 h-6" />
          </Button>

          <p className="text-sm text-gray-500 mt-4">
            Sorularınız mı var? <a href="mailto:destek@advancecash.io" className="text-purple-600 hover:underline">Bize ulaşın</a>
          </p>
        </div>

        {/* Footer Note */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <p className="text-xs text-gray-500">
            AdvanceCash.io - Çalışan Avans Yönetim Platformu
          </p>
        </div>
      </Card>
    </div>
  );
};

export default InviteExpired;
